import React from "react";

import { composeProviders } from "./app/context/_lib/composeProviders";
import { AdminProvider } from "./app/context/admin/AdminContext";
import { AdminsProvider } from "./app/context/admin/AdminManageContext";
import { BaseLevelProvider } from "./app/context/levels/BaseLevelContext";
import { CityProvider } from "./app/context/levels";
import { CompanyProvider } from "./app/context/CompanyContext";
import { CountryProvider } from "./app/context/CountryContext";
import { DashboardProvider } from "./app/context/DashboardContext";
import { DoSeeDataProvider } from "./app/context/DoSeeDataContext";
import { StaticProvider } from "./app/context/StaticContext";

// Ordered outermost → innermost. Every provider can read from the ones above it.
const RootProviders = composeProviders(
  AdminProvider,
  BaseLevelProvider,
  CompanyProvider,
  AdminsProvider,
  StaticProvider,
  DashboardProvider,
  DoSeeDataProvider,
  CountryProvider,
  CityProvider,
);

const Providers = ({ children }) => <RootProviders>{children}</RootProviders>;

export default Providers;
